<template>
  <div class="h-full">
    <div v-if="documents.length > 0">
      <li v-for="(item, index) in documents"  v-bind:key="index" class="block border-t border-gray-200">
        <a :href="item.links.url" class="block px-4 py-2 hover:bg-default-200">
          <div class="flex justify-between mb-1 font-semibold">
            <small>{{ item.type }}</small>
            <small>{{ item.publication.publication_at }}</small>
          </div>
          <h5 class="text-sm">{{ item.title }}</h5>
          <div class="document-description">{{ item.description }}</div>
        </a>
      </li>
    </div>
    <div v-else class="rounded-lg p-2 mx-4 mb-4 bg-yellow-100 text-yellow-900">
      Não existem documentos cadastrados
    </div>
  </div>
</template>

<script>
import Semed from "../api/Semed";
export default {
  name: 'DocumentComponent',
  data() {
    return {
      documents: []
    }
  },
  created () {
    Semed.get("/education/documents").then(response => {
        this.documents = response.data;
    });
  },
}
</script>

<style scoped>
.document-description{
  font-size: 0.6rem;
}
</style>
